/**
 * avatars/presets/textures/motifs.js
 * Các hàm tiện ích vẽ hoa văn truyền thống (Hoa sen, lá sen, cuống sen)
 */

// Mặt thân áo & tà áo cao ~1.6 lần bề rộng nên texture vuông bị giãn dọc:
// nén hoa & lá theo chiều dọc để hiển thị đúng tỉ lệ trên mô hình
export const MOTIF_ASPECT = 1.6;

/**
 * Hoa sen: 5 lớp cánh hồng nhạt → đậm, đài sen vàng; (x, y) là gốc hoa, r là chiều cao cánh
 */
export function drawLotusFlower(ctx, x, y, r, tilt = 0) {
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(1, 1 / MOTIF_ASPECT);
  ctx.rotate(tilt);
  const petal = (ang, len, wid, color) => {
    ctx.save();
    ctx.rotate(ang);
    ctx.fillStyle = color;
    // Cánh bầu tròn (đường cong bậc 3) để hoa nở đầy đặn thay vì thành nụ mảnh
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.bezierCurveTo(-wid, -len * 0.3, -wid * 0.8, -len * 0.85, 0, -len);
    ctx.bezierCurveTo(wid * 0.8, -len * 0.85, wid, -len * 0.3, 0, 0);
    ctx.fill();
    ctx.strokeStyle = 'rgba(219, 39, 119, 0.35)';
    ctx.lineWidth = Math.max(1, wid * 0.08);
    ctx.stroke();
    ctx.restore();
  };
  [-1.25, 1.25].forEach((a) => petal(a, r * 0.9, r * 0.75, '#fce7f3'));
  [-0.75, 0.75].forEach((a) => petal(a, r * 1.02, r * 0.8, '#fbcfe8'));
  [-0.32, 0.32].forEach((a) => petal(a, r * 1.1, r * 0.8, '#f9a8d4'));
  petal(0, r * 1.15, r * 0.72, '#f472b6');
  ctx.fillStyle = '#eab308';
  ctx.beginPath();
  ctx.ellipse(0, -r * 0.18, r * 0.24, r * 0.1, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
}

/**
 * Lá sen tròn nhìn nghiêng có gân toả từ tâm
 */
export function drawLotusLeaf(ctx, x, y, r, squash = 0.5) {
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(1, 1 / MOTIF_ASPECT);
  ctx.fillStyle = '#86efac';
  ctx.beginPath();
  ctx.ellipse(0, 0, r, r * squash, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#4ade80';
  ctx.lineWidth = r * 0.08;
  ctx.stroke();
  ctx.strokeStyle = 'rgba(22, 163, 74, 0.55)';
  ctx.lineWidth = r * 0.05;
  for (let i = 0; i < 7; i++) {
    const a = (i / 7) * Math.PI * 2;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(Math.cos(a) * r * 0.9, Math.sin(a) * r * squash * 0.9);
    ctx.stroke();
  }
  ctx.restore();
}

/**
 * Vẽ cuống sen uốn lượn mềm mại
 */
export function drawStem(ctx, pts, width) {
  ctx.strokeStyle = '#65a30d';
  ctx.lineWidth = width;
  ctx.lineCap = 'round';
  ctx.beginPath();
  ctx.moveTo(pts[0], pts[1]);
  ctx.quadraticCurveTo(pts[2], pts[3], pts[4], pts[5]);
  ctx.stroke();
}
